import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPatchAccrualBalanceWLRequestSchema,
  TPatchAccrualBalanceWLResponseSchema,
} from "./patchAccrualBalanceWL.schema";

export const patchAccrualBalanceWL = (axios: IAxiosInstance) => {
  return async ({
    companyID,
    id,
    employees,
  }: TPatchAccrualBalanceWLRequestSchema) => {
    const { data } = await axios.noRetry.patch<
      IApiResponse<TPatchAccrualBalanceWLResponseSchema>
    >(`/accrual-policies/${id}/balances?companyID=${companyID}`, {
      employees,
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Something went wrong");
  };
};
